import React from 'react'
import PropTypes from 'prop-types'
import { Button, makeStyles } from '@material-ui/core'
import Icon from '../../../../components/atoms/Icon'
import { getAttachmentIcon, getAttachmentPreviewText } from '../utils/attachmentUtils'

const useStyles = makeStyles((theme) => ({
  attachmentButton: {
    textTransform: 'none',
    backgroundColor: 'var(--dai-color-surface2)',
    fontSize: 'var(--font-size-xs)',
    color: 'var(--dai-color-accent)',
    border: 'var(--dai-border-accent)',
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
      borderColor: 'var(--dai-color-border-accent-hl)'
    }
  },
  attachmentIcon: {
    marginRight: 'var(--dim-1)'
  },
  previewText: {
    color: 'var(--dai-color-accent-low)',
    marginLeft: 'var(--dim-2)',
    fontSize: 'var(--font-size-xs)'
  }
}))

function AttachmentButton ({ onOpen, attachment }) {
  const classes = useStyles()

  return (
    <Button
      className={classes.attachmentButton}
      size='small'
      variant='outlined'
      onClick={() => onOpen?.(attachment)}
      startIcon={
        <Icon
          name={getAttachmentIcon(attachment.contentType)}
          className={classes.attachmentIcon}
          customSize={16}
        />
      }
    >
      {attachment.title}
      <span className={classes.previewText}>
        ({getAttachmentPreviewText(attachment)})
      </span>
    </Button>
  )
}

AttachmentButton.propTypes = {
  onOpen: PropTypes.func,
  attachment: PropTypes.object
}

export default AttachmentButton
